var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["@templates/components/organisms/card-house__instant-booking.html.njk"] = require( "@templates/components/organisms/card-house__instant-booking.html.njk" );
dependencies["@templates/components/organisms/card-house-extra-costs-info-button.macro.njk"] = require( "@templates/components/organisms/card-house-extra-costs-info-button.macro.njk" );
dependencies["@naturehouse/design-system/components/atoms/tool-tip/ToolTip.macro.njk"] = require( "@naturehouse/design-system/components/atoms/tool-tip/ToolTip.macro.njk" );




var shim = require("/symfony/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/components/organisms/card-house-price.html.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("@templates/components/organisms/card-house__instant-booking.html.njk", false, "templates/components/organisms/card-house-price.html.njk", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("instantBookingTemplate", t_1);
output += "\n";
env.getTemplate("@templates/components/organisms/card-house-extra-costs-info-button.macro.njk", false, "templates/components/organisms/card-house-price.html.njk", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("cardHouseExtraCostsInfoButton", t_4);
output += "\n";
env.getTemplate("@naturehouse/design-system/components/atoms/tool-tip/ToolTip.macro.njk", false, "templates/components/organisms/card-house-price.html.njk", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
context.setVariable("toolTip", t_7);
output += "\n\n";
var t_10;
t_10 = env.getTest("defined").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")) === true && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price"));
frame.set("has_price", t_10, true);
if(frame.topLevel) {
context.setVariable("has_price", t_10);
}
if(frame.topLevel) {
context.addExport("has_price", t_10);
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "has_price")) {
output += "\n    ";
if(!runtime.contextOrFrameLookup(context, frame, "compact")) {
output += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "isSearchLowestPriceVariantActive")) {
output += "\n            <div class=\"card__content__footer__date--lowest-price\">\n                <div>\n                    <span>\n                        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "arrivalDate"), env.opts.autoescape);
output += " - ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "departureDate"), env.opts.autoescape);
output += "\n                    </span>\n                    <span class=\"card__content__footer__date--separator\">•</span>\n                    <span>\n                        ";
var t_11;
t_11 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"totalWithDiscount");
frame.set("totalWithDiscount", t_11, true);
if(frame.topLevel) {
context.setVariable("totalWithDiscount", t_11);
}
if(frame.topLevel) {
context.addExport("totalWithDiscount", t_11);
}
output += "\n                        ";
if(!runtime.contextOrFrameLookup(context, frame, "totalWithDiscount")) {
output += "\n                            ";
var t_12;
t_12 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"total");
frame.set("totalWithDiscount", t_12, true);
if(frame.topLevel) {
context.setVariable("totalWithDiscount", t_12);
}
if(frame.topLevel) {
context.addExport("totalWithDiscount", t_12);
}
output += "\n                        ";
;
}
output += "\n                    </span>\n                </div>\n                <div>\n                    ";
output += runtime.suppressValue(env.getFilter("format_currency").call(context, runtime.contextOrFrameLookup(context, frame, "totalWithDiscount"),"EUR"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(env.getFilter("lower").call(context, env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"total"))), env.opts.autoescape);
output += "\n                </div>\n            </div>\n        ";
;
}
output += "\n        ";
if(!runtime.contextOrFrameLookup(context, frame, "isSearchLowestPriceVariantActive")) {
output += "\n            <div class=\"card__content__footer__date\">\n                <div>\n                    <span>\n                        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "arrivalDate"), env.opts.autoescape);
output += " - ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "departureDate"), env.opts.autoescape);
output += "\n                    </span>\n                    <span class=\"card__content__footer__date--separator\">•</span>\n                </div>\n                <data\n                    class=\"search__result__total-price\"\n                    value=\"";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"totalWithDiscount"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"total")), env.opts.autoescape);
output += "\"\n                    data-testid=\"house-card-total-price\"\n                >\n                    ";
var t_13;
t_13 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"totalWithDiscount");
frame.set("totalWithDiscount", t_13, true);
if(frame.topLevel) {
context.setVariable("totalWithDiscount", t_13);
}
if(frame.topLevel) {
context.addExport("totalWithDiscount", t_13);
}
output += "\n                    ";
if(!runtime.contextOrFrameLookup(context, frame, "totalWithDiscount")) {
output += "\n                        ";
var t_14;
t_14 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"total");
frame.set("totalWithDiscount", t_14, true);
if(frame.topLevel) {
context.setVariable("totalWithDiscount", t_14);
}
if(frame.topLevel) {
context.addExport("totalWithDiscount", t_14);
}
output += "\n                    ";
;
}
output += "\n                    ";
output += runtime.suppressValue(env.getFilter("format_currency").call(context, runtime.contextOrFrameLookup(context, frame, "totalWithDiscount"),"EUR"), env.opts.autoescape);
output += "\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "isPriceExcludingTouristTax")) {
output += "\n                        (";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"priceExcludingTouristTax")), env.opts.autoescape);
output += ")\n                    ";
;
}
output += "\n                </data>\n            </div>\n        ";
;
}
output += "\n    ";
;
}
output += "\n\n    ";
var t_15;
t_15 = ["search__result__price--container"];
frame.set("priceContainerClasses", t_15, true);
if(frame.topLevel) {
context.setVariable("priceContainerClasses", t_15);
}
if(frame.topLevel) {
context.addExport("priceContainerClasses", t_15);
}
output += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "compact") == true) {
output += "\n        ";
var t_16;
t_16 = env.getFilter("merge").call(context, runtime.contextOrFrameLookup(context, frame, "priceContainerClasses"),["search__result__price--container__compact"]);
frame.set("priceContainerClasses", t_16, true);
if(frame.topLevel) {
context.setVariable("priceContainerClasses", t_16);
}
if(frame.topLevel) {
context.addExport("priceContainerClasses", t_16);
}
output += "\n    ";
;
}
output += "\n\n    ";
if(env.getTest("defined").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")) === true) {
output += "\n        <div class=\"";
output += runtime.suppressValue(env.getFilter("join").call(context, runtime.contextOrFrameLookup(context, frame, "priceContainerClasses")," "), env.opts.autoescape);
output += "\">\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPriceWithDiscount")) {
output += "\n                <div class=\"search__result__price-discount\">\n                    <div class=\"search__result__per-night-label\">\n                        ";
if(!runtime.contextOrFrameLookup(context, frame, "userHasPeriodSelected") && runtime.contextOrFrameLookup(context, frame, "isSearchLowestPriceVariantActive")) {
output += "\n                            ";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"perNightFrom")), env.opts.autoescape);
output += "\n                        ";
;
}
else {
output += "\n                            ";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"perNight")), env.opts.autoescape);
output += "\n                        ";
;
}
output += "\n                    </div>\n                    <data class=\"search__result__day-price_discount\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPrice"), env.opts.autoescape);
output += "\">\n                        ";
output += runtime.suppressValue(env.getFilter("format_currency").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPrice"),"EUR"), env.opts.autoescape);
output += "\n                    </data>\n                </div>\n                <div class=\"search__result__price\">\n                    ";
if(runtime.inOperator("instantBooking",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"features"))) {
output += "\n                        ";
var t_17;
t_17 = (function() {
var output = "";
output += "\n                            ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 76, colno = 45, runtime.callWrap(runtime.memberLookup((t_7),"render"), "toolTip[\"render\"]", context, [{"id": "instant-booking-" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id"),"placement": "top","content": env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"instantBooking"))}]))), env.opts.autoescape);
output += "\n                        ";
;
return output;
})()
;
frame.set("instantBookingTooltip", t_17, true);
if(frame.topLevel) {
context.setVariable("instantBookingTooltip", t_17);
}
if(frame.topLevel) {
context.addExport("instantBookingTooltip", t_17);
}
output += "\n                        ";
output += runtime.suppressValue((lineno = 82, colno = 56, runtime.callWrap(runtime.memberLookup((t_1),"render"), "instantBookingTemplate[\"render\"]", context, [runtime.contextOrFrameLookup(context, frame, "instantBookingTooltip"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id")])), env.opts.autoescape);
output += "\n                    ";
;
}
output += "\n\n                    <data\n                        class=\"search__result__day-price search__result__day-price--discount\"\n                        value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPriceWithDiscount"), env.opts.autoescape);
output += "\"\n                    >\n                        ";
output += runtime.suppressValue(env.getFilter("format_currency").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPriceWithDiscount"),"EUR"), env.opts.autoescape);
output += "\n                    </data>\n                    <div class=\"search__result__info\">\n                        ";
var t_18;
t_18 = "extra-cost-template-" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id");
frame.set("template_id", t_18, true);
if(frame.topLevel) {
context.setVariable("template_id", t_18);
}
if(frame.topLevel) {
context.addExport("template_id", t_18);
}
output += "\n                        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 93, colno = 63, runtime.callWrap(runtime.memberLookup((t_4),"render"), "cardHouseExtraCostsInfoButton[\"render\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"startDate"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"endDate")]))), env.opts.autoescape);
output += "\n                    </div>\n                </div>\n            ";
;
}
else {
output += "\n                <div class=\"search__result__per-night-label\">\n                    ";
if(!runtime.contextOrFrameLookup(context, frame, "userHasPeriodSelected") && runtime.contextOrFrameLookup(context, frame, "isSearchLowestPriceVariantActive")) {
output += "\n                        ";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"perNightFrom")), env.opts.autoescape);
output += "\n                    ";
;
}
else {
output += "\n                        ";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"perNight")), env.opts.autoescape);
output += "\n                    ";
;
}
output += "\n                </div>\n                <div class=\"search__result__price\">\n                    ";
if(runtime.inOperator("instantBooking",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"features"))) {
output += "\n                        ";
var t_19;
t_19 = (function() {
var output = "";
output += "\n                            ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 107, colno = 45, runtime.callWrap(runtime.memberLookup((t_7),"render"), "toolTip[\"render\"]", context, [{"id": "instant-booking-" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id"),"placement": "top","content": env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"instantBooking"))}]))), env.opts.autoescape);
output += "\n                        ";
;
return output;
})()
;
frame.set("instantBookingTooltip", t_19, true);
if(frame.topLevel) {
context.setVariable("instantBookingTooltip", t_19);
}
if(frame.topLevel) {
context.addExport("instantBookingTooltip", t_19);
}
output += "\n                        ";
output += runtime.suppressValue((lineno = 113, colno = 56, runtime.callWrap(runtime.memberLookup((t_1),"render"), "instantBookingTemplate[\"render\"]", context, [runtime.contextOrFrameLookup(context, frame, "instantBookingTooltip"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id")])), env.opts.autoescape);
output += "\n                    ";
;
}
output += "\n                    <data class=\"search__result__day-price\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPrice"), env.opts.autoescape);
output += "\">\n                        ";
output += runtime.suppressValue(env.getFilter("format_currency").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"dayPrice"),"EUR"), env.opts.autoescape);
output += "\n                    </data>\n                    <div class=\"search__result__info\">\n                        ";
var t_20;
t_20 = "extra-cost-template-" + "" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id");
frame.set("template_id", t_20, true);
if(frame.topLevel) {
context.setVariable("template_id", t_20);
}
if(frame.topLevel) {
context.addExport("template_id", t_20);
}
output += "\n                        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 120, colno = 63, runtime.callWrap(runtime.memberLookup((t_4),"render"), "cardHouseExtraCostsInfoButton[\"render\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"id"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"startDate"),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"price")),"endDate")]))), env.opts.autoescape);
output += "\n                    </div>\n                </div>\n            ";
;
}
output += "\n        </div>\n    ";
;
}
output += "\n";
;
}
output += "\n\n<div class=\"card__content__cta\">\n    <a\n        data-role=\"open-house-detail\"\n        href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "house")),"websiteUrl"), env.opts.autoescape);
output += "\"\n        class=\"nh-button nh-button--primary\"\n        target=\"_blank\"\n        data-testid=\"house-card-cta-button\"\n    >\n        ";
output += runtime.suppressValue(env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "translations")),"view")), env.opts.autoescape);
output += "\n    </a>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/components/organisms/card-house-price.html.njk"] , dependencies)